export const formatNumber = (num, precision = 8) => {
    if (!num) return "";

    const str = num.toString();
    const parts = str.split('.');
    if (parts?.length === 1) {
        return `${str}.${'0'.repeat(precision)}`;
    }
    if (parts[1]?.length < precision) {
        return `${parts[0]}.${parts[1].padEnd(precision, '0')}`;
    }
    return precision === 0 ? `${parts[0]}` : `${parts[0]}.${parts[1].slice(0, precision)}`;
};

/**
 * Форматирует число с удалением лишних нулей в конце
 * @param {number} value - Число для форматирования
 * @param {number} maxDecimals - Максимальное количество десятичных знаков
 * @returns {string} - Отформатированная строка
 * @example
 * formatDecimal(0.00000001, 8) => "0.00000001"
 * formatDecimal(1.00000000, 8) => "1"
 * formatDecimal(0.12340000, 8) => "0.1234"
 */
export const formatDecimal = (value, maxDecimals = 8) => {
    return parseFloat(value).toFixed(maxDecimals).replace(/\.?0+$/, '');
};

/**
 * Форматирует сумму ставки, убирая ведущие нули
 * @param {string|number} value - Сумма ставки
 * @param {number} precision - Количество десятичных знаков (по умолчанию 8)
 * @returns {string} - Отформатированная строка
 * @example
 * formatBetAmount("0001.00000000") => "1.00000000"
 * formatBetAmount("0001.001000") => "1.00100000"
 * formatBetAmount("0.00000001") => "0.00000001"
 */
export const formatBetAmount = (value, precision = 8) => {
    if (!value && value !== 0) return "";

    // Преобразуем в число и обратно в строку чтобы убрать ведущие нули
    const num = parseFloat(value);
    if (isNaN(num)) return "";

    return num.toFixed(precision);
};